export default __webpack_public_path__ + "static/media/favicon.e1e57dd9.png";